import { Navigate } from "react-router-dom";
import { WorkspaceShell } from "@/pages/crm/workspace/WorkspaceShell";
import { useCRMAuth } from "@/contexts/CRMAuthContext";

// Authenticated CRM workspace; unauthenticated visitors go to CRM sign-in.
const CRMAppPage = () => {
  const { crmUser, loading } = useCRMAuth();
  if (loading) return <div className="min-h-screen bg-[#F3F4F6]" data-testid="crm-app-loading" />;
  if (!crmUser) return <Navigate to="/crm/login" replace />;
  return <WorkspaceShell />;
};

export default CRMAppPage;
